// extracted by mini-css-extract-plugin
export default {"errorMessage":"TextInputDialog_errorMessage__P0QNP","field":"TextInputDialog_field__88Hkj font-sm-regular"};